import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";
import { nextjsPlugin, onRouterTransitionStart } from "@datadog/browser-rum-nextjs";
import {
  getDatadogEnv,
  getDatadogRumApplicationId,
  getDatadogRumClientToken,
  getDatadogRumSessionSampleRate,
  getDatadogRumSessionReplaySampleRate,
  getDatadogService,
  getDatadogSite,
  getDatadogVersion,
  isDatadogLogsConfigured,
  isDatadogRumConfigured,
} from "@/lib/datadog/config";

export { onRouterTransitionStart };

const datadogClientConfig = {
  clientToken: getDatadogRumClientToken()!,
  site: getDatadogSite(),
  service: getDatadogService(),
  env: getDatadogEnv(),
  version: getDatadogVersion(),
};

if (isDatadogLogsConfigured()) {
  datadogLogs.init({
    ...datadogClientConfig,
    forwardErrorsToLogs: true,
    sessionSampleRate: getDatadogRumSessionSampleRate(),
  });
}

if (isDatadogRumConfigured()) {
  datadogRum.init({
    applicationId: getDatadogRumApplicationId()!,
    ...datadogClientConfig,
    sessionSampleRate: getDatadogRumSessionSampleRate(),
    sessionReplaySampleRate: getDatadogRumSessionReplaySampleRate(),
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    plugins: [nextjsPlugin()],
    allowedTracingUrls: [
      { match: "/api", propagatorTypes: ["datadog"] },
      (url) => typeof url === "string" && url.includes("/api/"),
    ],
  });
}
